import styled from 'styled-components'
import { MuiTelInput } from 'mui-tel-input'

export const MuiTelInputStyled = styled(MuiTelInput)`
  height: 32px;
  & {
    width: 100%;
    height: 32px;
    background-color: white;
  }
  > div {
    border: 1px solid #EFEFEF;
    height: 32px;
  } 
    & input {
        font-size: 12px;
    }
  & fieldset {
      border: 0px;
  }  
  .MuiTelInput-IconButton {
    width: unset;
    // without this rule, right part of the flag is cropped
  }
`
